module.exports = __webpack_public_path__ + "static/img/HLL_H5.9de5ad0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/HLL_H5.png
// module id = 65Mf
// module chunks = 34